import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { StaticQuery, graphql } from 'gatsby';

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet
          title={data.site.siteMetadata.title}
          meta={[
            { name: 'description', content: 'Jessi McLennon Nutrition' },
            {
              name: 'keywords',
              content:
                'nutrition, diet, food, recipes, weightloss, jessi, mclennon',
            },
          ]}
        >
          <html lang="en" />
        </Helmet>
        <div className="font-serif text-grey-darkest h-full">
          {children}
        </div>
      </>
    )}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
